import analysisModule from "../analysisModule"

analysisModule.service("r2NodeCommands", [
    "NodeCommandExecutor",
    "nodeCommandBatchEdition",
    "commonNodeCommandExecutor",
    "nodeCommandResolveOrderBreak",
    "nodeCommandServeTrip",
    "nodeCommandViewTripEdition",
    "nodeCommandSelectNodes",
    "nodeCommandPublishTrip",
    "nodeCommandUnselectNodes",
    "nodeCommandReprogramTrip",
    "nodeCommandInvoiceView",
    "nodeCommandStartMonitorableConfiguration",
    "nodeCommandExportAllTripPickingList",
    "nodeCommandOpenDeliveryOverviewMonitoring",
    "nodeCommandPublishRoutingSessionTrip",
    function (NodeCommandExecutor,
              nodeCommandBatchEdition,
              commonNodeCommandExecutor,
              nodeCommandResolveOrderBreak,
              nodeCommandServeTrip,
              nodeCommandViewTripEdition,
              nodeCommandSelectNodes,
              nodeCommandPublishTrip,
              nodeCommandUnselectNodes,
              nodeCommandReprogramTrip,
              nodeCommandInvoiceView,
              nodeCommandStartMonitorableConfiguration,
              nodeCommandExportAllTripPickingList,
              nodeCommandOpenDeliveryOverviewMonitoring,
              nodeCommandPublishRoutingSessionTrip) {
        let commandMap = {
            "nodeCommandBatchEdition":nodeCommandBatchEdition,
            "nodeCommandResolveOrderBreak": nodeCommandResolveOrderBreak,
            "nodeCommandServeTrip": nodeCommandServeTrip,
            "nodeCommandViewTripEdition": nodeCommandViewTripEdition,
            "selectNodesCommand": nodeCommandSelectNodes,
            "unselectNodesCommand": nodeCommandUnselectNodes,
            "nodeCommandPublishTrip": nodeCommandPublishTrip,
            "UnreleaseTripCommand": nodeCommandReprogramTrip,
            "nodeCommandInvoiceView": nodeCommandInvoiceView,
            "nodeCommandStartMonitorableConfiguration": nodeCommandStartMonitorableConfiguration,
            "nodeCommandExportAllTripPickingList": nodeCommandExportAllTripPickingList,
            "openDeliveryOverviewMonitoringTripCommand": nodeCommandOpenDeliveryOverviewMonitoring,
            "nodeCommandPublishRoutingSessionTrip": nodeCommandPublishRoutingSessionTrip
        }
        return new NodeCommandExecutor(commandMap, commonNodeCommandExecutor)
    }])